import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { ImageSettings } from '@legacy/common-ui-utility-components';
import { getImageSettingsFromRendering } from '@legacy/common-ui-utility-components';
import { InnogyComponentRendering } from '@core/jss-models';
import { getTreeListValues } from '@core/jss-utils';

import { ListConfig } from '../list.model';

@Component({
  selector: 'wl-list-variant-base',
  template: '',
})
export abstract class ListVariantBaseComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() listConfig?: ListConfig;

  imageSettings?: ImageSettings;
  listItems = [];

  ngOnInit() {
    if (this.rendering) {
      this.imageSettings = getImageSettingsFromRendering(this.rendering);
      this.listItems = getTreeListValues(this.rendering?.fields, 'Items');
    }
  }
}
